<template>
    <div id='stop-covid'>
        <section class='jumbo-wrapper'>
            <b-container class='mt-3 greeting-block'>

                
                        <!-- <b-row class='community-logos my-3' align-v="center" align-h="center">
                            <b-col lg='2' cols='4'>
                                <b-link href='https://ecosafety.ru/ru/' target='_blank'><b-img src="./dist/ecosagety_logo_group_2018.svg" class='company-name' fluid></b-img></b-link>
                            </b-col>
                            <b-col lg='2' cols='4'>
                                <b-link href='http://gcmp.ru/' target='_blank'><b-img src="./dist/logo-gcmp-02.svg" class='company-name' fluid></b-img></b-link>
                            </b-col>
                           
                           
                        </b-row> -->
                        <!-- <b-row class='community-logos my-3' align-v="center" align-h="center">
                            <b-col lg='2' cols='4'>
                                <b-link href='https://www.makcm.ru/' target='_blank'><b-img src="./dist/max_m_logo.png" class='company-name ' fluid></b-img></b-link>
                            </b-col>
                             <b-col lg='2' cols='4'>
                                <b-link href='https://gsmk.ru/' target='_blank'><b-img src="./dist/gsmk-logo.png" class='company-name' fluid></b-img></b-link>
                            </b-col>
                            <b-col lg='2' cols='4'>
                                <b-link href='https://kapmed.ru/' target='_blank'><b-img src="./dist/kapital_logo.png" class='company-name' fluid></b-img></b-link>
                            </b-col>
                            <b-col lg='2' cols='4'>
                                <b-link href='https://www.sogaz-med.ru/' target='_blank'><b-img src="./dist/logo_sogaz.png" class='company-name' fluid></b-img></b-link>
                            </b-col>
                            
                        </b-row> -->
                        
                    <b-row>
                        <b-col class='platform-column' >
                            <b-img src="./dist/medsafe.png" class='platform-logo mx-auto' fluid></b-img>
                        </b-col>
                      
                    </b-row>
            </b-container>       


        </section>
        
        <b-navbar id='footer'>            
            <b-container>     
                <p class='ml-auto'>«‎ООО МедСейф»™ © 2021</p>
            </b-container>
        </b-navbar>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import smoothHeight from "../components/smoothHeight";

export default {
    name: 'stop-covid',
    components: { smoothHeight },
    data() {
        return {
            isExpanded: false,
            smallDevice: false,
            windowWidth: 0,
            disposition: 'Распоряжение Комитета по здравоохранению Правительства Санкт-Петербурга № 229-р от 16.04.2020 <br> «Об организации оказания медицинской  помощи на дому в условиях эпидемии COVID-19 в Санкт-Петербурге»',
            decree: 'Постановление главного государственного санитарного врача по городу Санкт-Петербургу № 7 от 13.04.2020 <br> «О проведении дополнительных санитарно-противоэпидемических (профилактических) мероприятий по недопущению распространения новой коронавирусной инфекции, вызванной COVID-2019 в учреждениях социальной защиты населения в городе Санкт-Петербурге»',
            reportSKFields: [
                { key: 'SMO', label: 'Страховая компания' },
                { key: 'n_c', label: 'Обзвонили' },
                { key: 'n_o', label: 'Нуждаются в помощи' },
                { key: 'n_o_pr', label: '%' },
                { key: 'n_r', label: 'Выполнено заявок' },
                { key: 'n_r_pr', label: '%' },
            ],
            reportAreaFields: [
                { key: 'distrinct', label: 'Район' },
                { key: 'n_c', label: 'Обзвонили' },
                { key: 'n_o', label: 'Нуждаются в помощи' },
                { key: 'n_o_pr', label: '%' },
                { key: 'n_r', label: 'Выполнено заявок' },
                { key: 'n_r_pr', label: '%' },
            ],
            reportOrderFields: [
                { key: 'type_order', label: 'Тип заказа' },
                { key: 'sent', label: 'Принято' },
                { key: 'done', label: 'Выполнено' },
                { key: 'refus_doer', label: 'Отказы исполнителей' },
                { key: 'wait', label: 'В ожидании' },
            ]
        }
    },
    computed: {
        ...mapState({
            reportSK: state => state.covid.reportSK,
            reportArea: state => state.covid.reportArea,
            reportOrder: state => state.covid.reportOrder,
            reportSKProcessing: state => state.covid.reportSKProcessing,
            reportAreaProcessing: state => state.covid.reportAreaProcessing,
            reportOrderProcessing: state => state.covid.reportOrderProcessing
        })
    },
    methods: {
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth;
            if (this.windowWidth <= 586 ) {
                this.smallDevice = true;
            } else this.smallDevice = false
        }
    },
    mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);

            this.getWindowWidth()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
}

</script>

<style>

.expand-link {
    color: #0D4A8E;
    text-align: justify;
}
.administration {
    height: 80px;
    margin: auto;
    display: block;
}
.administration-title {
    display: block;
    font-size: 0.5rem;
    text-align: center;
    min-width: 33%;
    color: #000;
    margin: auto;
}
.company-name {
    margin: auto;
    display: block;
}
.komitet,
.komitet2,
.group {
    display: block;
    margin: auto;
}
.expand-link:hover {
    text-decoration: underline;
}
.decree-link {
    color: #fff;
}
.decree-button:hover {
    background-color: #0face3;
    border: 1px solid #0face3;
}
.decree-link:hover {
    color: #fff;
}
.decree-button {
    background-color: #0D4A8E;
    border-radius: 10px;
    height: 40px;
    min-width: 70px;
    border: 1px solid  #0D4A8E;
    display: block;
    margin-top: 20px;
}
.conditions {
    margin-top: 2rem;
}
.about-text {
    color: #0D4A8E;
    text-indent: 1.5em;
    text-align: justify;
}
#stop-covid {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 84px);
}
.container-about {
    margin-bottom: 80px;
}
.jumbo-wrapper {
    flex: 1 0 auto;
}
.report-header {
    color: #0D4A8E;
}
#report-sk-table {
    color: #0D4A8E;
    margin-bottom: 80px;
}
#report-area-table {
    color: #0D4A8E;
    margin-bottom: 80px;
}
#report-order-table {
    color: #0D4A8E;
}
.komitet {
    height: 110px;
}
.komitet2 {
    height: 120px;
}
.group {
    width: 200px;
    margin-top: 20px;
}
#footer {
    color: #0D4A8E;
    background-color: #F6F6F6;
    flex: 0 1 auto;
    padding-top: 1rem;
}
.greeting-block {
    margin-bottom: 80px;
}
.platform-logo {
    width: 300px;
    min-height: auto;
    margin: 0 auto 0 0;
}
.platform-column {
    display: flex;
}

.moto-column {
    display: flex;
}
.moto {
    margin: auto auto 15px auto;
    font-size: 1.65rem;
    color: #0D4A8E;
}
.community-logos {
    text-align: right;
}

@media (max-width: 991px) {
    .moto {
        text-align: center;
    }
    .platform-logo {
        margin: 0 auto;
    }
}
@media (max-width: 536px) {
    #eco {
        width: 130px;
    }
    #gcmp {
        width: 160px;
        margin-top: 0;
    }
    #skytel {
        width: 130px;
        margin-top: -65px;
        margin-right: 35px;
    }
    .group {
        margin-top: 0;
    }
 
    .label {
        font-size: 2.5rem;
    }
    .lead {
        font-size: 1rem;
    }
    .report-header {
        font-size: 1rem;
    }
    .report {
        font-size: 0.8rem;
    }
    .platform-logo {
        width: 150px;
        max-height: 80px;
    }
    .moto {
        font-size: 1rem;
        text-align: center;
    }
    .community-logos {
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/StopCovid.vue